import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { StarInput, StarsRow } from '../../../components/NewReviewModal';
import { getGeneralRating } from '../../../selectors/newReview';
import { setGeneralRating } from '../../../actions/newReview';
import { REVIEWS_VALUES } from '../../../constants/reviews';
import { isActive, isHovered } from './utils';

export function GeneralRatingContainer() {
  const name = 'generalRating';
  const dispatch = useDispatch();
  const current = useSelector(getGeneralRating);
  const [hover, setHover] = React.useState<number | null>(null);

  const setCurrentRating = (value: number) => () => {
    dispatch(setGeneralRating(value));
  };

  const onMouseEnter = (value: number) => () => {
    setHover(value);
  };

  const onMouseLeave = () => {
    setHover(null);
  };

  return (
    <StarsRow title="Общая оценка">
      {REVIEWS_VALUES.map(value => {
        return (
          <StarInput
            isActive={isActive({ value, current })}
            isHover={isHovered({ value, hover })}
            name={name}
            value={value}
            key={`${name}_${value}`}
            onClick={setCurrentRating(value)}
            onMouseEnter={onMouseEnter(value)}
            onMouseLeave={onMouseLeave}
          />
        );
      })}
    </StarsRow>
  );
}
